import { errorView } from '@krp/client-runtime'
import type { TimingsLoad } from '@krp/platform-ui'

/** Минимум результата запроса RTK Query, нужный показу времени поиска. */
interface TimingsQueryLike<T> {
  data?: T | undefined
  isError: boolean
  error?: unknown
}

/**
 * Результат запроса времени поиска → состояние показа. 404 — записи нет (тестовая область, сбой записи или истёк срок хранения): это не ошибка
 * человека; остальные сбои показываются словами сервера с кодом запроса для администратора.
 */
export function toTimingsLoad<T>(query: TimingsQueryLike<T>): TimingsLoad<T> {
  if (query.isError) {
    const view = errorView(query.error)
    return view.status === 404 ? { status: 'missing' } : { status: 'error', message: view.message, correlationId: view.correlationId }
  }
  return query.data === undefined ? { status: 'loading' } : { status: 'ready', data: query.data }
}
